var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron.backward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.95728 11.7119C6.95728 11.9683 7.05249 12.188 7.25757 12.3784L12.9558 17.9595C13.1169 18.1206 13.322 18.2085 13.5637 18.2085C14.0471 18.2085 14.4353 17.8276 14.4353 17.3369C14.4353 17.0952 14.3328 16.8828 14.1716 16.7144L9.03735 11.7119L14.1716 6.70947C14.3328 6.54102 14.4353 6.32129 14.4353 6.08691C14.4353 5.59619 14.0471 5.21533 13.5637 5.21533C13.322 5.21533 13.1169 5.30322 12.9558 5.46436L7.25757 11.0381C7.05249 11.2358 6.95728 11.4556 6.95728 11.7119Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.111852025ac7685ffbc4c12167ed9d56.svg";
export { ForwardRef as ReactComponent };